import React, { useState } from 'react';
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import { TextField, Button } from '@material-ui/core';
import { parseURL } from '../../sc-utilities';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

import * as actions from './actions';

const styles = theme => ({
    main: {
        width: "auto",
        display: "block", // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(6))]: {
            width: 400,
            marginLeft: "auto",
            marginRight: "auto"
        }
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
    },
    inputField: {
        width: '100%',
        margin: '5px'
    },
    submitButton: {
        color: theme.palette.buttonText.default,
        width: '100%',
        margin: '5px'
    },
    logo: {
        width: "250px",
        margin: "10px"
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const EmailVerification = props => {
    const { classes } = props;
    let queryParams = parseURL(window.location.href);

    const [voucherCode, setVoucherCode] = useState(queryParams ? queryParams.code : '');
    const [formValid, setFormValid] = useState(false);
    const [result, setResult] = useState({ open: false, message: '', status: null, done: false });

    const handleVoucherCodeChange = event => {
        let newValue = '';
        let counter = 1;
        let voucherPattern = /^[A-Z0-9]+$/i;
        for (var letter of event.currentTarget.value) {
            if (counter === 17) {
                return;
            }
            letter = letter.toUpperCase();
            if (voucherPattern.test(letter)) {
                newValue += counter === 5 || counter === 9 || counter === 13 ? ' - ' : '';
                newValue += letter;
                counter++;
            }
        }

        setVoucherCode(newValue);
    }

    const handleEmailChanhe = event => {
        let emailPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/g;
        if (emailPattern.test(event.currentTarget.value)) {
            setFormValid(true);
        } else {
            setFormValid(false);
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setResult({ ...result, open: false });
    };

    const handleSubmit = async event => {
        let email = document.getElementById("email").value;

        let result = await actions.verifyEmail(email, voucherCode);

        if (result.status) {
            setResult({ open: true, message: 'Confirmation email with instructions successfully sent. Please check your email', status: 'success', done: true })
        } else {
            setResult({ open: true, message: result.message, status: 'error' })
        }
    }

    return <main className={classes.main}>
        <CssBaseline />
        <Paper className={classes.paper}>
            <img
                alt="App logo"
                className={classes.logo}
                src={props.logoPath ? process.env.PUBLIC_URL + props.logoPath : process.env.PUBLIC_URL + "/assets/images/app-logo.svg"}
            />
            <h3>Voucher verification</h3>
            <TextField disabled={result.done} className={classes.inputField} id="email" label="Email" onChange={handleEmailChanhe} />
            <TextField className={classes.inputField} id="voucherCode" label="Voucher code" value={voucherCode} onChange={handleVoucherCodeChange} />
            <Button disabled={!formValid || result.done} variant="contained" color="primary" className={classes.submitButton} onClick={handleSubmit}>Submit</Button>
        </Paper>
        <Snackbar open={result.open} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity={result.status}>
                {result.message}
            </Alert>
        </Snackbar>
    </main>
}

export default (withStyles(styles)(EmailVerification));
